import React, { Component } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { isAuthenticated } from "../auth";
import { read, update, updateUser } from "./apiUser";
import { Redirect } from "react-router-dom";

class EditProfile extends Component {
  constructor() {
    super();
    this.state = {
      id: "",
      name: "",
      lastName: "",
      companyName: "",
      companyType: "",
      email: "",
      originalEmail: "",
      confirmEmailOpen: false,
      password: "",
      redirectToProfile: false,
      error: "",
      fileSize: 0,
      loading: false,
      about: ""
    };
  }

  init = userId => {
    const token = isAuthenticated().token;
    read(userId, token).then(data => {
      if (data.error) {
        this.setState({ redirectToProfile: true });
      } else {        
        this.setState({
          id: data._id,
          name: data.name,         
          companyName: data.companyName,
          lastName: data.lastName,
          companyType: data.companyType,
          email: data.email || "",
          originalEmail: data.email || "",
          error: "",
          about: data.about
        });
      }
    });
  };

  componentDidMount() {
    this.userData = new FormData();
    const userId = this.props.match.params.userId;
    this.init(userId);
  }

  // isValid = () => {
  //   const { name, password } = this.state;
  //   // if (fileSize > 1000000) {
  //   //   this.setState({
  //   //     error: "File size should be less than 100kb",
  //   //     loading: false
  //   //   });
  //   //   return false;
  //   // }
  //   if (this.state.name.length === 0) {
  //     this.setState({ error: "Name is required", loading: false });
  //     return false;
  //   }
    
  //   if (password.length >= 1 && password.length <= 5) {
  //     this.setState({
  //       error: "Password must be at least 6 characters long",
  //       loading: false
  //     });
  //     return false;
  //   }
  //   return true;
  // };

  handleChange = name => event => {
    this.setState({ error: "" });
    const value = name === "photo" ? event.target.files[0] : event.target.value;

    const fileSize = name === "photo" ? event.target.files[0].size : 0;
    this.userData.set(name, value);
    this.setState({ [name]: value, fileSize });
  };


  emailChanged = () =>
    this.state.email.trim().toLowerCase() !==
    this.state.originalEmail.trim().toLowerCase();

  clickSubmit = event => {
    event.preventDefault();

    const email = this.state.email.trim();
    if (email.length === 0) {
      this.setState({ error: "Email is required" });
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.setState({ error: "Please enter a valid email address" });
      return;
    }

    // Changing the email changes the address they sign in with, so make them
    // confirm it before it goes anywhere.
    if (this.emailChanged()) {
      this.setState({ confirmEmailOpen: true });
      return;
    }

    this.saveProfile();
  };

  saveProfile = () => {
    this.setState({ loading: true, confirmEmailOpen: false });

    const userId = this.props.match.params.userId;
    const token = isAuthenticated().token;
    update(userId, token, {
      name: this.state.name,
      lastName: this.state.lastName,
      email: this.state.email.trim(),
      companyName: this.state.companyName,
      companyType: this.state.companyType,
      about: this.state.about
    }).then(data => {
      if (data.error) {
        // Without clearing loading the form stays hidden behind the spinner and
        // the user cannot correct a rejected email.
        this.setState({ error: data.error, loading: false });
      } else {
        // Always refresh the stored profile: this form only ever edits the
        // signed-in user, so an admin editing it is editing their own record
        // and would otherwise keep a stale email in localStorage.
        updateUser(data, () => {
          this.setState({ redirectToProfile: true });
        });
      }
    });
  };

  signupForm = (name, lastName, email, companyName, companyType, password, about) => (
    <Box component="form">
      <TextField
        fullWidth
        label="First Name"
        type="text"
        value={this.state.name}
        onChange={this.handleChange("name")}
        margin="normal"
        variant="outlined"
      />

      <TextField
        fullWidth
        label="Last Name"
        type="text"
        value={this.state.lastName}
        onChange={this.handleChange("lastName")}
        margin="normal"
        variant="outlined"
      />

      <TextField
        fullWidth
        label="Email"
        type="email"
        value={this.state.email}
        onChange={this.handleChange("email")}
        margin="normal"
        variant="outlined"
        helperText={
          this.emailChanged()
            ? "This is the address you sign in with - you will need the new one next time you log in."
            : "The address you sign in with, and where committee mail is sent."
        }
      />

      <TextField
        fullWidth
        label="Company Name"
        type="text"
        value={this.state.companyName}
        onChange={this.handleChange("companyName")}
        margin="normal"
        variant="outlined"
      />

      <FormControl fullWidth margin="normal" variant="outlined">
        <InputLabel>Company Type</InputLabel>
        <Select
          value={this.state.companyType}
          onChange={this.handleChange('companyType')}
          label="Company Type"
        >
          <MenuItem value="">
            <em>-- Select company type --</em>
          </MenuItem>
          <MenuItem value="Utility">Utility Company</MenuItem>
          <MenuItem value="Services">Engineering Services Provider</MenuItem>
          <MenuItem value="Vendor">Vendor</MenuItem>
        </Select>
      </FormControl>

      <TextField
        fullWidth
        label="About"
        multiline
        rows={4}
        value={this.state.about}
        onChange={this.handleChange("about")}
        margin="normal"
        variant="outlined"
      />

      <TextField
        fullWidth
        label="Password"
        type="password"
        value={password}
        onChange={this.handleChange("password")}
        margin="normal"
        variant="outlined"
      />

      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={this.clickSubmit}
        sx={{ mt: 3 }}
      >
        Update
      </Button>

      <Dialog
        open={this.state.confirmEmailOpen}
        onClose={() => this.setState({ confirmEmailOpen: false })}
      >
        <DialogTitle>Change your sign-in email?</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Box sx={{ mb: 2 }}>
              Your email will change from <strong>{this.state.originalEmail}</strong> to{' '}
              <strong>{this.state.email.trim()}</strong>.
            </Box>
            <Box>
              You will sign in with the new address from now on, and password resets
              will be sent there. Make sure you can receive mail at it.
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => this.setState({ confirmEmailOpen: false })}>
            Cancel
          </Button>
          <Button onClick={this.saveProfile} variant="contained" color="primary">
            Change email
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );

  render() {
    const {
      id,
      name,
      lastName,
      companyName,
      companyType,
      email,
      password,
      redirectToProfile,
      error,
      loading,
      about
    } = this.state;

    if (redirectToProfile) {
      return <Redirect to={`/user/${id}`} />;
    }

    return (
      <Container maxWidth="md">
        <Typography variant="h4" sx={{ mt: 5, mb: 5 }}>
          Edit {this.state.name}'s Profile
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {loading ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 10,
              backgroundColor: '#e9ecef',
              borderRadius: 2
            }}
          >
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Loading...
            </Typography>
          </Box>
        ) : (
          isAuthenticated().userId === id &&
          this.signupForm(name, lastName, email, companyName, companyType, password, about)
        )}
      </Container>
    );
  }
}

export default EditProfile;